import "./ReportsOverview.css";

import { ReportsOverview } from "./ReportsOverview";

export const InternalReportsOverview = () => {
    return <ReportsOverview isInternal={true} />;
};
